import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, ButtonToolbar } from 'reactstrap';
import CoinImg from '../../../assets/images/Image_coins-07.png';
import { useDict } from '../../../contexts/LanguageContext';
import ROUTE_NAME from '../../../routes/RouteName';

const Completed = () => {
    const navigate = useNavigate();

    const dict = useDict();

    const doClickInvestmentPage = (e) => {
        e.preventDefault();
        navigate(ROUTE_NAME.INVEST_NOW);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div
            className="card card-completed"
            style={{ height: '100vh', marginLeft: 'auto', marginRight: 'auto' }}
        >
            <div className="card__body">
                <img
                    className="image-completed"
                    src={CoinImg}
                    alt="icons"
                />
                <p className="complete-word" style={{ marginTop: '20px' }}>
                    {dict.registrationComplete} <br />
                    {dict.continueInvesting}
                </p>
                <ButtonToolbar className="form__button-toolbar wizard__toolbar">
                    <Button
                        className="pricing-card__button rounded btn-invest-page"
                        color="primary"
                        onClick={doClickInvestmentPage}
                        data-cy="firstTimeLoginCompleted__continueBtn"
                    >
                        {dict.proceed}
                    </Button>
                </ButtonToolbar>
            </div>
        </div>
    );
};

export default Completed;
